<div class="pension-reserve-charts">

  <div class="pies" *ngIf="showCharts">

    <div class="estimated-reserve">
      <h2 i18n>Montant estimé à l'échéance</h2>
      <div class="amount">
        {{ produtsModel?.totalEstimatedPensionAmount | cCurrency }}
      </div>
      <div class="chart">
        <ngx-charts-pie-chart
          [view]="[200,200]"
          [scheme]="colorScheme"
          [results]="estimatedReservebreackdownModel"
          [labels]="false"
          [doughnut]="false"
          (activate)="onPieActivate($event,PensionAmountField.ESTIVMATED_PENSION_RESERVE)"
          (deactivate)="onPieDeactivate($event,PensionAmountField.ESTIVMATED_PENSION_RESERVE)"
        >
        </ngx-charts-pie-chart>
      </div>
      <p class="legal-strings" *ngIf="showLegalStrings">
        Simulation des compagnies (non contractuel) si vous continuez à verser les primes.
        Hors participations bénéficiaires éventuelles.
      </p>
    </div>

    <div class="vested">
      <h2 i18n>Réserves</h2>
      <div class="amount">
        {{ produtsModel?.totalVestedReserveAmount | cCurrency }}
      </div>
      <div class="chart">
        <ngx-charts-pie-chart
          [view]="[200,200]"
          [scheme]="colorScheme"
          [results]="vestedReserveBreakdownModel"
          [labels]="false"
          [doughnut]="false"
          (activate)="onPieActivate($event,PensionAmountField.VESTED_RESERVE)"
          (deactivate)="onPieDeactivate($event,PensionAmountField.VESTED_RESERVE)"
        >
        </ngx-charts-pie-chart>
      </div>
      <p class="legal-strings" *ngIf="showLegalStrings">
        Réserve déjà acquise au moment de la mise à jour. Partitipations bénéficiaires incluses.
      </p>
    </div>

    <div class="estimated-incomes">
      <h2 i18n>Rente estimée à l'échéance</h2>
      <div class="amount">
        {{ 1000 + (produtsModel?.totalEstimatedPensionAmount / 12 / 20) | cCurrency }} / mois
      </div>
      <div class="chart">
        <ngx-charts-pie-chart
          [view]="[200,200]"
          [scheme]="colorScheme"
          [results]="estimatedIncomeBreakdownModel"
          [labels]="false"
          [doughnut]="false"
          (activate)="onPieActivate($event,PensionAmountField.ESTIMATED_PENSION_INCOME)"
          (deactivate)="onPieDeactivate($event,PensionAmountField.ESTIMATED_PENSION_INCOME)"
        >
        </ngx-charts-pie-chart>
      </div>

      <p class="legal-strings" *ngIf="showLegalStrings">
        Cette estimation se base sur le montant estimé à l'échéance obtenu à partir de la simulation des compagnies.
        Elle considère 20 ans de rente, et inclut en addition une rente légale estimée à 1000€.
        Contactez votre conseiller fiscal pour plus d'informations.
      </p>
    </div>

  </div>


  <div class="legend" *ngIf="showLegend">

    <header class="products-legend-header">
      <h2 i18n>Légende</h2>

    </header>

    <div *ngFor="let model of legendModel" class="sub-item"
         [style.color]="model.colorString"
         [class.hasSelection]="selectedInsurance !== null"
         [class.selected]="selectedInsurance?.id === model.insuranceSubscription.id"
    >
      <div class="color-box"
           [style.backgroundColor]="model.colorString"
      ></div>
      <div class="item-col">

        <div class="item">
          <cf-insurance-subscription-item [showSubTitle]="false"
                                          [showDetails]="false"
                                          [showFooter]="false"
                                          [insuranceSubscription]="model.insuranceSubscription"
                                          [headerCollapsable]="false"
          ></cf-insurance-subscription-item>
        </div>
        <div class="amounts">
          <div>
            <span i18n>Réserve estimée à l'échéance: </span>
            {{ model.estimatedPensionAMount | cCurrency }}
          </div>
          <div>
            <span i18n>Réserves: </span>
            {{ model.vestedReserveAmount | cCurrency }}
          </div>
          <div>
            <span i18n>Rente estimée à l'échéance: </span>
            {{ model.estimatedPensionIncomeAmount | cCurrency }} / mois
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
